import { memo } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { getCookie } from '@utils/cookie';

// 공통 컴포넌트
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';
import Login from '@pages/Auth/Login';
import FindEmail from '@pages/Auth/FindEmail';
import ResetPassword from '@pages/Auth/ResetPassword';
import Join from '@pages/Auth/Join';
import Equipment from '@pages/Equipment';
import EquipmentDetail from '@pages/Equipment/Detail';
import EditEquipment from '@pages/Equipment/Edit';
import Faq from '@pages/Faq';
import FaqDetail from '@pages/Faq/Detail';
import Notice from '@pages/Notice';
import NoticeDetail from '@pages/Notice/Detail';
import Profile from '@pages/Profile';

const LoggedOutRoutes = memo(() => (
    <Routes>
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/find-id" element={<FindEmail />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />
        <Route path="/auth/join" element={<Join />} />
        <Route path="/auth/advertiser/login" element={<Login />} />
        <Route path="/auth/advertiser/find-id" element={<FindEmail />} />
        <Route
            path="/auth/advertiser/reset-password"
            element={<ResetPassword />}
        />
        <Route path="/*" element={<Navigate replace to="/auth/login" />} />
    </Routes>
));

const LoggedInRoutes = memo(() => {
    return (
        <Routes>
            <Route path="/main" element={<Equipment />} />
            <Route path="/equipment/:id" element={<EquipmentDetail />} />
            <Route path="/equipment/:id/edit" element={<EditEquipment />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/faq/:id" element={<FaqDetail />} />
            <Route path="/notice" element={<Notice />} />
            <Route path="/notice/:id" element={<NoticeDetail />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/*" element={<Navigate replace to="/equipment" />} />
        </Routes>
    );
});

const Router = ({ isLoggedIn = true }: { isLoggedIn: boolean }) => {
    const { pathname } = useLocation();
    if (!isLoggedIn)
        return (
            <Wrapper>
                <Header />
                <LoggedOutRoutes />
            </Wrapper>
        );

    if (pathname.split('/')[3] === 'popup') return <LoggedInRoutes />;

    return (
        <>
            <Header />
            <LoggedInRoutes />
            <Footer />
        </>
    );
};

export default Router;

const Wrapper = styled.div`
    width: 100%;
    /* height: 100vh; */
`;
